import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { post } from '../utils/api';

export default function SetupPassword({ onLogin }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError('Password must be at least 8 characters');
    if (password !== confirm) return setError('Passwords do not match');
    setError('');
    setLoading(true);
    try {
      const data = await post('/auth/setup-password', { token, password });
      onLogin(data.token, data.user);
    } catch (err) {
      setError(err.message || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <h1>Invalid Link</h1>
          <p>This invite link is missing or invalid. Please check your email for the correct link.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Set Your Password</h1>
        <p>Welcome to the Mi Assessment Review System</p>
        {error && <div className="form-error">{error}</div>}
        <div className="form-group">
          <label>New Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                 placeholder="At least 8 characters" required minLength={8} />
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                 placeholder="Repeat your password" required />
        </div>
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Setting up...' : 'Create Account'}
        </button>
      </form>
    </div>
  );
}
